import { useRouteError } from 'react-router-dom';

export default function ErrorElement() {
  const error = useRouteError();

  if (!error) return null;

  throw error;
}
